module.exports = __webpack_public_path__ + "static/media/tronlink.8d412b1f.png";